// API Configuration
const getBaseUrl = () => {
  const localUrl = import.meta.env.VITE_LOCAL_API_URL;
  const testUrl = import.meta.env.VITE_TEST_API_URL;
  const prodUrl = import.meta.env.VITE_API_URL;

  console.log('Environment variables:', {
    VITE_LOCAL_API_URL: localUrl,
    VITE_TEST_API_URL: testUrl,
    VITE_API_URL: prodUrl,
    currentUrl: typeof window !== 'undefined' ? window.location.href : 'SSR',
  });

  // Check if running locally
  if (typeof window !== 'undefined' && window.location.href.includes('localhost')) {
    const url = localUrl || 'http://localhost:6019';
    console.log('Using local API URL:', url);
    return url;
  }

  // Check if running on test environment
  if (typeof window !== 'undefined' && window.location.href.includes('test')) {
    const url = testUrl || 'https://backend.app.patentloop.com';
    console.log('Using test API URL:', url);
    return url;
  }

  // Default to production
  const url = prodUrl || testUrl || 'https://backend.app.patentloop.com';
  console.log('Using production API URL:', url);
  return url;
};

export const API_CONFIG = {
  get baseUrl() {
    return getBaseUrl();
  },
  endpoints: {
    auth: {
      login: '/user/login',
      signup: '/user/signup',
      confirmSignup: '/user/confirm_signup',
      resendCode: '/user/resend_code',
      forgotPassword: '/user/forgot_password',
      confirmNewPassword: '/user/confirm_new_password',
      logout: '/user/logout',
      checkLogin: '/user/check_login',
      oauthExchange: '/user/oauth/exchange',
    },
    user: {
      fetchSettings: '/user/fetch_settings',
      updateSettings: '/user/update_settings',
      savePrompt: '/user/save_prompt',
      updatePrompt: '/user/update_prompt',
      fetchPrompts: '/user/fetch_prompts',
      deletePrompt: '/user/delete_prompt',
      saveEmailTemplate: '/user/save_email_template',
      fetchEmailTemplates: '/user/fetch_email_templates',
      deleteEmailTemplate: '/user/delete_email_template',
      autoGenerateEmailTemplate: '/user/auto_generate_email_template',
    },
    chat: {
      sendMessage: '/chat/message',
      getMessage: '/chat/get_message',
      feedback: '/chat/feedback',
    },
    session: {
      addSession: '/session/add_session',
      saveSession: '/session/save_session',
    },
  },
  timeout: 30000,
  withCredentials: true,
};

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
